import { message } from "skin/event";
import { status } from "skin/event/status";

const fn = async (conf, options) => {
  try {
    const fileHandle = await window.showSaveFilePicker(options);
    const writableStream = await fileHandle.createWritable();
    await writableStream.write(conf);
    await writableStream.close();
    message("Сохранено");
  } catch (e) {
    console.log(e);
    message("Отменено");
  }
};

// Выгрузка json конфигурации в txt файл
const next = async (obj, ms, story, data, d, action) => {
  const conf = data.curData.values.fld?.configure;
  const code = data.curData.values.fld?.nm;
  const options = {
    suggestedName: `configure_pc_${code}.txt`,
    types: [
      {
        description: "Text",
        accept: {
          "text/plain": ".txt",
        },
      },
    ],
    excludeAcceptAllOption: true,
  };
  await fn(conf, options);
  return status.action;
};

export default next;
